/* import __COLOCATED_TEMPLATE__ from './confirmation-wrapper.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './confirmation-wrapper.module.scss';

@classic
@classNames(styles.component)
export default class RequestConfirmationConfirmationWrapper extends Component {}
